import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=f0adf038"
import script from "./LeadPage.vue?vue&type=script&lang=js"
export * from "./LeadPage.vue?vue&type=script&lang=js"
import style0 from "./LeadPage.vue?vue&type=style&index=0&id=f0adf038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports